import {
     LOAD_TRIGGER_IMAGES_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_TRIGGER_IMAGES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/marketingAutomations/TriggerImagesReducer.js